module.exports = __webpack_public_path__ + "img/icon_map_huanjingjiankong_zaixian.6d604453.svg";